import './TextSizeToolbarItem.d924d2bed579148e16bf5a53918acc79.css';
export default {"textSizeItem":"_textSizeItem_o26mp_1","disabled":"_disabled_o26mp_1"};